import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { ReceiptDetail, ReceiptDetailResponse } from '../../../types/api';

export function useReceiptDetail(encId: string) {
  return useQuery<ReceiptDetail>({
    queryKey: queryKeys.receipts.detail(encId),
    queryFn: async () => {
      const res = await apiClient.get<ReceiptDetailResponse>(endpoints.receipts.detail(encId));
      return res.data.receipt;
    },
    staleTime: 30_000,
    enabled: Boolean(encId),
  });
}
